var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 235,
    viewBox: "0 0 295 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5285 98.5044L87.1735 132.002V132.002C86.9662 131.287 86.2639 130.835 85.5273 130.941C82.6494 131.357 76.2026 132.289 76.2026 132.289L77.7822 99.7718L79.5285 98.5044Z",
    fill: "#653494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5285 98.5044L87.1735 132.002V132.002C86.9662 131.287 86.2639 130.835 85.5273 130.941C82.6494 131.357 76.2026 132.289 76.2026 132.289L77.7822 99.7718L79.5285 98.5044Z",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.79 49.1697C268.88 48.6629 268.741 48.1422 268.41 47.7477C268.079 47.3532 267.59 47.1251 267.075 47.1251C260.925 47.1251 242.786 47.1251 235.66 47.1251C233.97 47.1251 232.524 48.3385 232.23 50.0026C230.831 57.9218 226.948 79.9048 225.743 86.7246C225.654 87.2314 225.793 87.7521 226.124 88.1466C226.455 88.5411 226.943 88.7688 227.458 88.7688C233.609 88.7688 251.747 88.7688 258.873 88.7688C260.564 88.7688 262.01 87.5558 262.303 85.8917C263.702 77.9725 267.585 55.9895 268.79 49.1697ZM138.585 136.037C138.675 135.53 138.535 135.009 138.204 134.615C137.874 134.22 137.385 133.992 136.87 133.992C132.72 133.992 123.391 133.992 118.626 133.992C116.936 133.992 115.49 135.205 115.196 136.87C114.241 142.277 112.2 153.834 111.37 158.528C111.281 159.035 111.42 159.556 111.751 159.95C112.082 160.345 112.571 160.572 113.085 160.572C117.235 160.572 126.564 160.572 131.329 160.572C133.019 160.572 134.465 159.359 134.759 157.695C135.714 152.287 137.756 140.73 138.585 136.037ZM94.8231 24.4699C94.9128 23.9631 94.7735 23.4424 94.4426 23.0479C94.1117 22.6534 93.6232 22.4253 93.1081 22.4253C89.565 22.4253 82.3415 22.4253 78.2902 22.4253C76.6005 22.4253 75.1542 23.6383 74.8603 25.3027C74.0396 29.9496 72.4417 38.9947 71.7268 43.0429C71.6371 43.5502 71.7765 44.0709 72.1074 44.4653C72.4382 44.8598 72.9267 45.0875 73.4418 45.0875C76.985 45.0875 84.2084 45.0875 88.2597 45.0875C89.9494 45.0875 91.3953 43.8745 91.6896 42.21C92.5103 37.5632 94.1082 28.5181 94.8231 24.4699Z",
    fill: "#F2F4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0194 131.083L54.6874 141.315L54.3631 135.877L41.0194 131.083Z",
    fill: "#E3E1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0194 131.083L54.6874 141.315L54.3631 135.877L41.0194 131.083Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.129 29.5474C209.472 29.5474 213.973 29.5474 218.135 29.5474C219.536 29.5474 220.865 30.1704 221.761 31.2475C222.657 32.3251 223.028 33.7449 222.772 35.1225C219.639 52.0315 210.458 101.586 210.458 101.586C210.458 101.586 213.19 103.84 213.638 101.351C215.99 88.2942 223.108 48.7696 225.648 34.6731C225.876 33.4036 225.531 32.0983 224.703 31.1087C223.876 30.1195 222.653 29.5474 221.363 29.5474C216.446 29.5474 213.751 29.5474 212.129 29.5474Z",
    fill: "#D8CCEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.125 105.293C149.125 105.293 154.177 113.656 157.575 119.283C158.19 120.302 158.209 121.572 157.625 122.608C157.04 123.644 155.942 124.285 154.753 124.285C149.127 124.285 140.916 124.285 137.032 124.285C136.451 124.285 135.893 124.516 135.482 124.927C135.071 125.338 134.841 125.895 134.841 126.477C134.841 126.588 134.841 126.654 134.841 126.654H163.901C167.763 121.998 172.064 117.661 177.19 113.921L171.979 105.293H149.125ZM64.0611 197.124C69.8852 200.619 73.7867 206.996 73.7867 214.277C73.7867 223.048 68.1263 230.506 60.2619 233.196L59.3607 232.216L57.3148 231.421L55.0817 229.507L53.1573 225.079L53.4233 223.17L52.5195 222.35L52.2038 221.942L64.0611 197.124ZM50.9029 194.597L46.3949 218.379L45.9203 220.533L44.7727 221.238L43.4552 223.252L42.3789 224.749L44.1697 228.171L47.1024 233.115C39.36 230.36 33.8097 222.961 33.8097 214.277C33.8097 204.509 41.6362 196.334 50.9029 194.597Z",
    fill: "#E3E1FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0713 63.4839C79.7711 72.1515 80.4934 79.702 73.414 79.4033",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7694 77.3984L74.0586 82.0723",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4898 69.9793H65.5584C65.1334 69.9793 64.7259 70.1478 64.4255 70.4487C64.1251 70.7491 63.9562 71.1566 63.9562 71.5816C63.9562 71.582 63.9562 71.5824 63.9562 71.5829C63.9562 72.4676 64.6737 73.1851 65.5584 73.1851C66.8907 73.1851 68.5695 73.1851 68.5695 73.1851C68.8651 76.6272 68.2634 79.4132 65.7439 80.7677C65.7439 80.7677 64.0816 79.8682 61.9821 78.7323C57.2691 76.1814 55.447 70.339 57.8747 65.5611C57.8747 65.5611 57.8747 65.5606 57.8747 65.5602C59.0751 63.1982 61.168 61.4118 63.6893 60.5977C66.2106 59.7831 68.9531 60.0077 71.3081 61.2216C72.5258 61.8494 73.3679 62.2835 73.3679 62.2835L69.7363 65.467C69.7363 65.467 69.951 68.6932 70.0738 70.5331C70.0864 70.7199 69.9793 70.8945 69.8073 70.9685C69.6353 71.043 69.435 71.0003 69.3079 70.8627C68.8965 70.4182 68.4898 69.9793 68.4898 69.9793Z",
    fill: "#200849"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2969 71.6846H67.4459",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0194 104.464C82.9107 96.4312 100.733 80.0102 106.627 63.4369L102.087 55.5503L89.3265 74.4695L71.1183 83.0984C71.1183 83.0984 71.1183 83.0984 71.1179 83.0984C68.7816 82.1214 66.1523 82.1166 63.8121 83.0845C61.4723 84.0519 59.6146 85.9127 58.6506 88.2542C52.5727 103.019 41.0193 131.083 41.0193 131.083L75.6567 143.526L77.7932 99.545M75.5396 67.947C75.5396 67.947 77.4244 68.921 78.647 69.5527C78.8629 69.6642 79.0044 69.8805 79.0201 70.1231C79.0362 70.3651 78.9239 70.5981 78.7245 70.7365C78.0666 71.1941 77.306 71.7222 77.306 71.7222L75.5396 67.947Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.208 59.915L109.913 55.8271L111.258 55.9443",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.507 52.5269C110.507 52.5269 111.317 52.6501 111.953 52.7467C112.152 52.7768 112.33 52.8852 112.448 53.0471C112.566 53.2091 112.616 53.412 112.584 53.6101M110.241 54.1905C110.241 54.1905 111.051 54.3137 111.688 54.4103C111.886 54.4404 112.064 54.5483 112.183 54.7107C112.301 54.8727 112.35 55.0752 112.318 55.2737L110.241 54.1905Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5164 134.63C27.7034 134.309 15.9508 129.65 8.50894 120.381C-10.0328 97.2838 5.04137 54.0997 42.4181 24.3403C73.6722 -0.544099 105.735 -4.8322 119.08 7.70339C128.228 16.2974 123.971 37.9226 114.032 47.6569M123.785 94.9445C119.503 99.5012 114.768 103.895 109.609 108.036C101.739 114.353 93.5105 119.584 85.2512 123.686L123.785 94.9445Z",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7217 134.65C82.7217 134.65 84.4967 134.28 85.8839 133.99C86.3132 133.901 86.6889 133.645 86.9288 133.278C87.1687 132.911 87.2532 132.464 87.1635 132.035C87.0555 131.521 86.9641 131.083 86.9641 131.083L79.5286 98.5044",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2823 132.289C82.2823 132.289 90.5563 165.707 92.3192 172.827C92.5377 173.709 92.7228 174.6 92.8734 175.497C93.9871 182.113 98.8769 211.161 100.057 218.172C100.271 219.438 99.7294 220.712 98.6701 221.437C97.691 222.117 96.6204 222.384 95.4622 222.276C94.3868 222.196 93.4198 221.592 92.8769 220.66C84.8014 206.803 79.4314 192.591 77.793 177.9C70.3327 168.048 64.8921 157.755 61.9772 143.53C60.4812 141.743 59.0519 139.251 58.7776 137.441",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5996 134.089C80.4581 136.361 79.5102 138.328 77.7931 140.005M54.3629 135.877C54.1186 137.976 54.2405 140.551 55.6668 142.961C56.2542 152.042 58.6827 162.764 61.0447 173.925C53.0023 184.796 48.5605 199.191 46.8137 214.542C48.5731 213.88 50.3834 214.011 51.2834 214.34C53.8012 215.259 54.2614 217.041 52.8582 220.48C52.8582 220.48 68.8564 186.614 73.5794 176.615C74.3853 174.91 74.2412 172.907 73.2002 171.334C73.0665 171.132 72.9816 171.004 72.9816 171.004C72.9816 171.004 74.4458 173.312 72.9407 170.939C67.9482 163.069 64.2173 154.46 61.9773 143.53C60.4813 141.743 59.0519 139.251 58.7777 137.441L54.3629 135.877Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.412 221.516C52.412 221.516 52.4642 221.558 52.5448 221.624C53.0938 222.073 53.382 222.767 53.3136 223.473C53.2401 224.226 53.1573 225.079 53.1573 225.079L55.0817 229.507C56.6121 230.977 57.2138 231.409 58.6854 231.867C59.3542 232.097 59.8749 232.631 60.0882 233.305C60.2563 233.796 60.4048 234.266 60.4048 234.266H47.9014M42.9572 224.167C42.9572 224.167 43.5171 223.139 44.0992 222.069C44.8284 220.73 46.4598 220.169 47.8578 220.778C48.1273 220.896 48.399 221.014 48.6616 221.128C49.9246 221.678 50.872 222.769 51.2403 224.096C51.2403 224.097 51.2403 224.097 51.2403 224.097L53.7982 218.379L42.9572 224.167Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2126 225.579C47.3162 224.084 45.7009 223.17 43.958 223.17H43.9576C43.389 223.17 42.8639 223.476 42.584 223.971C42.3036 224.466 42.311 225.073 42.6036 225.561C44.5602 228.822 47.8256 234.265 47.8256 234.265H53.4233C53.4233 234.265 50.1705 228.843 48.2126 225.579Z",
    fill: "#200849"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.579 224.312C101.579 224.312 102.333 224.425 103.085 224.538C103.994 224.675 104.73 225.346 104.951 226.238C105.158 227.075 105.376 227.957 105.376 227.957C105.376 227.957 110.357 231 111.814 231.89C112.081 232.053 112.308 232.273 112.479 232.534C112.586 232.697 112.714 232.896 112.841 233.104C112.962 233.381 112.936 233.7 112.771 233.953C112.605 234.206 112.323 234.358 112.021 234.358C107.728 234.379 95.279 234.379 95.279 234.379C95.279 234.379 95.0757 234.075 94.8175 233.69C94.1553 232.701 94.0155 231.451 94.4426 230.34C94.6024 229.924 94.7792 229.465 94.9594 228.996C95.2982 228.114 96.0509 227.458 96.9696 227.241C97.8887 227.025 98.8553 227.277 99.5519 227.914C100.786 229.044 101.92 230.082 101.92 230.082",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.956 229.199C102.027 229.035 102.802 228.49 102.652 227.975L100.76 221.468",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4897 221.421L96.5 227.396",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9701 234.378H273.168",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.587 218.887C179.047 228.098 168.955 234.266 157.433 234.266C139.957 234.266 125.77 220.078 125.77 202.602C125.77 185.127 139.957 170.939 157.433 170.939C158.539 170.939 159.632 170.996 160.709 171.108",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.708 171.107C176.648 172.749 189.096 186.234 189.096 202.602C189.096 208.556 187.449 214.129 184.587 218.887C170.738 207.349 161.648 190.292 160.708 171.107Z",
    fill: "#653494"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.708 171.107C176.648 172.749 189.096 186.234 189.096 202.602C189.096 208.556 187.449 214.129 184.587 218.887C170.738 207.349 161.648 190.292 160.708 171.107Z",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M191.797 15.3403H135.597C132.499 15.3403 129.987 17.8521 129.987 20.9503C129.987 36.4417 129.987 78.6749 129.987 78.6749M227.084 101.352C263.763 101.352 293.541 131.13 293.541 167.809C293.541 204.488 263.763 234.266 227.084 234.266C190.406 234.266 160.627 204.488 160.627 167.809C160.627 131.13 190.406 101.352 227.084 101.352Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.503 92.3062V29.1929",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.549 41.3135C167.838 41.3135 175.38 48.8556 175.38 58.145C175.38 67.4344 167.838 74.9761 158.549 74.9761C149.26 74.9761 141.718 67.4344 141.718 58.145C141.718 48.8556 149.26 41.3135 158.549 41.3135Z",
    fill: "#653494"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.125 105.293C149.125 105.293 154.177 113.656 157.575 119.283C158.19 120.302 158.209 121.572 157.625 122.608C157.04 123.644 155.942 124.285 154.753 124.285C149.127 124.285 140.916 124.285 137.032 124.285C136.451 124.285 135.893 124.516 135.482 124.927C135.071 125.338 134.841 125.895 134.841 126.477C134.841 126.588 134.841 126.654 134.841 126.654H163.901C167.763 121.998 172.064 117.661 177.19 113.921L171.979 105.293H149.125Z",
    fill: "#E3E1FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.549 41.3135C167.838 41.3135 175.38 48.8556 175.38 58.145C175.38 67.4344 167.838 74.9761 158.549 74.9761C149.26 74.9761 141.718 67.4344 141.718 58.145C141.718 48.8556 149.26 41.3135 158.549 41.3135Z",
    fill: "#653494"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.364 220.346C291.114 220.346 294.158 223.39 294.158 227.14C294.158 230.89 291.114 233.934 287.364 233.934C283.615 233.934 280.57 230.89 280.57 227.14C280.57 223.39 283.615 220.346 287.364 220.346Z",
    fill: "#F2F4FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.84 65.5332L169.155 53.2188L166.692 50.7559L156.84 60.6073L151.915 55.6818L149.452 58.1448L156.84 65.5332Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.929 25.0507C150.929 24.4803 150.703 23.9331 150.299 23.5299C149.896 23.1263 149.349 22.8999 148.779 22.8999C147.301 22.8999 145.347 22.8999 143.869 22.8999C143.298 22.8999 142.751 23.1263 142.348 23.5299C141.944 23.9331 141.718 24.4803 141.718 25.0507V25.0511C141.718 25.6215 141.944 26.1688 142.348 26.5719C142.751 26.9755 143.298 27.2019 143.869 27.2019C145.347 27.2019 147.301 27.2019 148.779 27.2019C149.349 27.2019 149.896 26.9755 150.299 26.5719C150.703 26.1688 150.929 25.6215 150.929 25.0511V25.0507Z",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M146.324 25.0508H159.27",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.718 31.5815H159.27",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M141.718 80.5112H175.38",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M141.718 85.8682H175.38",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M141.718 37.2388H150.93",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.503 29.1934H196.09V19.6332C196.09 17.2626 194.168 15.3403 191.797 15.3403C191.797 15.3403 191.796 15.3403 191.796 15.3403C189.425 15.3403 187.503 17.2626 187.503 19.6332C187.503 23.7015 187.503 29.1934 187.503 29.1934Z",
    fill: "#200849"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M129.987 29.5478H119.312C116.784 29.5478 114.619 31.3581 114.17 33.8464C113.406 38.0914 113.338 38.4653 111.896 46.4712M109.688 58.7312C106.695 75.3507 103.938 90.6545 102.224 100.168C101.996 101.438 102.342 102.743 103.169 103.733C103.996 104.722 105.22 105.294 106.509 105.294C122.029 105.294 168.431 105.294 193.422 105.294M210.457 101.586C212.809 88.5285 219.971 48.77 222.51 34.6736C222.738 33.404 222.393 32.0987 221.565 31.1091C220.738 30.1199 219.515 29.5478 218.225 29.5478C208.432 29.5478 208.749 29.5478 187.503 29.5478M187.503 29.1934H196.09V19.6332C196.09 17.2626 194.168 15.3403 191.797 15.3403H191.796C189.425 15.3403 187.503 17.2626 187.503 19.6332C187.503 23.7015 187.503 29.1934 187.503 29.1934ZM102.402 55.9804C102.402 55.9804 104.877 52.8705 105.532 52.0472C105.636 51.9161 105.763 51.806 105.908 51.7215C107.019 51.0732 112.067 48.1274 114.007 46.9954C114.122 46.9284 114.266 46.941 114.368 47.0268C114.469 47.1125 114.506 47.2527 114.459 47.3768L114.459 47.3781C114.308 47.7787 114.072 48.1422 113.768 48.4435C112.857 49.3456 110.915 51.2674 110.915 51.2674C110.915 51.2674 111.298 51.2765 111.762 51.2879C112.124 51.2966 112.457 51.4851 112.65 51.7907C112.844 52.0959 112.872 52.4778 112.726 52.8082C112.712 52.84 112.704 52.8579 112.704 52.8579C112.704 52.8579 112.389 54.8302 112.208 55.9652C112.131 56.4472 111.8 56.8499 111.342 57.0193C111.085 57.1142 110.86 57.1973 110.86 57.1973H109.823L102.402 55.9804Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M213.638 101.351C215.989 88.2942 223.108 48.7696 225.648 34.6731C225.876 33.4036 225.53 32.0983 224.703 31.1087C223.876 30.1195 222.653 29.5474 221.363 29.5474C216.446 29.5474 213.751 29.5474 212.129 29.5474",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.357 95.042C160.361 95.042 161.695 96.669 161.334 98.6735C160.973 100.678 159.053 102.305 157.049 102.305C155.045 102.305 153.711 100.678 154.072 98.6735C154.433 96.669 156.353 95.042 158.357 95.042Z",
    fill: "#E3E1FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M212.129 92.3066H135.246",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.41 92.3066H103.656",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M149.125 105.293C149.125 105.293 154.177 113.656 157.575 119.283C158.19 120.302 158.209 121.572 157.625 122.608C157.04 123.644 155.942 124.285 154.753 124.285C149.127 124.285 140.916 124.285 137.032 124.285C136.451 124.285 135.893 124.516 135.482 124.927C135.071 125.338 134.841 125.895 134.841 126.477C134.841 126.588 134.841 126.654 134.841 126.654",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M102.156 126.654H163.901",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M146.446 124.286H161.394",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.294 111.806C179.239 112.482 178.205 113.187 177.19 113.921L171.979 105.293H176.361L180.294 111.806Z",
    fill: "#200849"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M202.199 190.07C205.79 197.525 212.717 204.367 227.854 204.367C241.964 204.367 251.97 197.423 251.97 186.394C251.97 161.681 206.175 167.911 206.175 146.364C206.175 138.093 214 131.251 227.469 131.251C240.168 131.251 245.941 137.48 248.379 141.564M180.294 111.806C179.239 112.482 178.205 113.187 177.19 113.921L171.979 105.293H176.361L180.294 111.806Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M222.919 125.719V209.899",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.25 125.719V209.899",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.41 90.4633L131.128 98.0102L139.899 76.3398L112.41 90.4633Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.899 76.3398L118.615 92.965L120.565 98.8619L139.899 76.3398Z",
    fill: "#200849"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.899 76.3398L118.615 92.965L120.565 98.8619L139.899 76.3398Z",
    stroke: "#200849",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M216.07 234.266C203.153 234.266 191.091 230.572 180.885 224.185M149.613 167.809C149.613 131.13 179.391 101.352 216.07 101.352H227.084",
    stroke: "#653494",
    strokeWidth: 0.870769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsIcon);
export default __webpack_public_path__ + "static/media/congrats-icon.add450c5766c9adfac5df5b77a860b38.svg";
export { ForwardRef as ReactComponent };